import { File05 } from '@untitled-ui/icons-react/build/cjs';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import PageSectionLayout from 'src/components/PageSectionLayout';
import Header from 'src/components/PageSectionLayout/Header/Header';
import { AppDispatch } from 'src/redux/store';

import { fetchInvoices } from '../../redux/documentHub.slice';

import InvoiceListView from './InvoicesView';

const defaultInvoiceParams = {
    search: '',
    sortType: 'desc',
    sortField: 'createdAt',
    page: 1,
    limit: 25,
    status: 'all',
    startDate: null,
    endDate: null,
};

const DocumentHub = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch<AppDispatch>();

    // Client decision — the POD tab was merged into the Invoice table: orders that have PODs but
    // no portal-visible invoice now appear as rows with "-" invoice columns and a POD icon.
    const [activeTab, setActiveTab] = useState('invoices');
    const [tabsData] = useState<any[]>([{ value: 'invoices', name: t('DocumentHub.All_Documents') }]);

    useEffect(() => {
        dispatch(fetchInvoices(defaultInvoiceParams));
    }, [dispatch]);

    return (
        <PageSectionLayout header={<Header title={t('DocumentHub.Document_Hub')} Icon={File05} isShowNotificationBox />}>
            <InvoiceListView activeTab={activeTab} setActiveTab={setActiveTab} tabsData={tabsData} />
        </PageSectionLayout>
    );
};

export default DocumentHub;
